import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iq-central-front-end-yinka-modal',
  templateUrl: './yinka-modal.component.html',
  styleUrls: ['./yinka-modal.component.css']
})
export class YinkaModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
